import ISvgProps from 'src/SvgLoader/ISvgProps';

const ComputerIcon = (props: ISvgProps) => (
	<svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M15.7 31.8516V29.4071H18.1V26.9627H10.9C10.24 26.9627 9.675 26.7233 9.205 26.2446C8.735 25.7659 8.5 25.1905 8.5 24.5182V12.296C8.5 11.6238 8.735 11.0483 9.205 10.5696C9.675 10.0909 10.24 9.85156 10.9 9.85156H30.1C30.76 9.85156 31.325 10.0909 31.795 10.5696C32.265 11.0483 32.5 11.6238 32.5 12.296V24.5182C32.5 25.1905 32.265 25.7659 31.795 26.2446C31.325 26.7233 30.76 26.9627 30.1 26.9627H22.9V29.4071H25.3V31.8516H15.7ZM10.9 24.5182H30.1V12.296H10.9V24.5182Z"
			fill={props.primaryColor}
		/>
	</svg>
);

export default ComputerIcon;
